import { render, staticRenderFns } from "./changeHistory.vue?vue&type=template&id=fc02c7d6&scoped=true&"
import script from "./changeHistory.vue?vue&type=script&lang=js&"
export * from "./changeHistory.vue?vue&type=script&lang=js&"
import style0 from "./changeHistory.vue?vue&type=style&index=0&id=fc02c7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc02c7d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
